import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

interface UseOpenPageResult {
  handleOpenPage: (id: string) => void;
}

const useOpenPage = (): UseOpenPageResult => {
  const navigate = useNavigate();
  const handleOpenPage = useCallback(
    (id: string) => {
      navigate(`/pc/${id}`);
    },
    [navigate],
  );

  return {
    handleOpenPage,
  };
};

export default useOpenPage;
